var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "border-top font-size-12 font-size-lg-16 color-2c"
  }, [_c('div', {
    staticClass: "d-flex py-4 py-lg-10 border-bottom"
  }, [_c('p', {
    staticClass: "font-weight-bold mr-2 mr-lg-48 w-40px"
  }, [_vm._v(" 지름 ")]), _c('p', [_vm._v(" " + _vm._s(_vm.diameter) + " ")])]), _c('div', {
    staticClass: "d-flex py-4 py-lg-10 border-bottom"
  }, [_c('p', {
    staticClass: "font-weight-bold mr-2 mr-lg-48 w-40px"
  }, [_vm._v(" 판두께 ")]), _c('p', [_vm._v(" " + _vm._s(_vm.weight) + " ")])]), _c('div', {
    staticClass: "d-flex py-4 py-lg-10 border-bottom"
  }, [_c('p', {
    staticClass: "font-weight-bold mr-2 mr-lg-48 w-40px"
  }, [_vm._v(" 전장 ")]), _c('p', [_vm._v(" " + _vm._s(_vm.length) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }